export async function getLinkToken(base, linkId) {
    const result = await fetch(`${base}/api/v1/resource/link?id=${linkId}`, {
        method: "GET",
    });
    if (!result.ok)
        throw result;
    return result.json();
}
export async function getUserToken(base, resource, auth, activeGroup) {
    // const jobId = resource.split('/')[2];
    const result = await fetch(`${base}/api/v1/resource${resource}?activeGroup=${activeGroup}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${auth}`,
        }
    });
    return result.json();
}
//# sourceMappingURL=resource.js.map